export const API_PATH_ApiDeviceMgmtVTreeSearchAll = '/services/devices-management/apiDeviceMgmtVTreeSearchAll';
